interface TranscriptSpeaker {
  sessionId: string;
  speaker: string;
  speakerId?: string | null;
  source?: string;
}

export function transcriptSpeakerKey(segment: TranscriptSpeaker): string {
  return JSON.stringify([
    (segment.source === 'google-gemini' ||
      segment.source === 'gemini-transcribe-flash') &&
    segment.speakerId
      ? 'visit'
      : segment.sessionId,
    segment.speakerId ? 'voice' : 'role',
    segment.speakerId || segment.speaker,
  ]);
}

export function numberTranscriptSpeakers(
  segments: TranscriptSpeaker[],
): Map<string, number> {
  const numbers = new Map<string, number>();
  segments.forEach((segment) => {
    const key = transcriptSpeakerKey(segment);
    if (segment.speakerId && !numbers.has(key))
      numbers.set(key, numbers.size + 1);
  });
  return numbers;
}
